/**
 * Форма входа в админку разработчиков.
 */

import { useState } from "react";
import { API_BASE_URL } from "../../config/constants";
import { setDevToken } from "../../utils/devAuth";

function DevLogin({ onSuccess }) {
    const [login, setLogin] = useState("");
    const [password, setPassword] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsSubmitting(true);
        setError("");

        try {
            const response = await fetch(`${API_BASE_URL}/dev/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ login, password }),
            });
            const data = await response.json().catch(() => ({}));

            if (!response.ok || !data.token) {
                throw new Error(data.error || "Login failed");
            }

            setDevToken(data.token);
            onSuccess(data.token);
            console.info("Вход в админку выполнен");
        } catch (err) {
            console.error("Ошибка входа в админку:", err);
            setError(err.message || "Login failed");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="dev-admin">
            <div className="dev-admin__terminal">
                <div className="dev-admin__header">
                    <span className="dev-admin__title">Developer login</span>
                    <div className="dev-admin__dots">
                        <span className="dev-admin__dot" />
                        <span className="dev-admin__dot" />
                        <span className="dev-admin__dot" />
                    </div>
                </div>
                <div className="dev-admin__body">
                    <form className="dev-admin__form" onSubmit={handleSubmit}>
                        {error ? (
                            <div className="dev-admin__status dev-admin__status_error">{error}</div>
                        ) : null}
                        <input
                            className="dev-admin__input"
                            type="text"
                            name="login"
                            autoComplete="username"
                            placeholder="Login *"
                            value={login}
                            onChange={(event) => setLogin(event.target.value)}
                            required
                        />
                        <input
                            className="dev-admin__input"
                            type="password"
                            name="password"
                            autoComplete="current-password"
                            placeholder="Password *"
                            value={password}
                            onChange={(event) => setPassword(event.target.value)}
                            required
                        />
                        <button className="dev-admin__submit" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? "Checking..." : "Sign in"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default DevLogin;
// components/DevAdmin/DevLogin.js
